import { reduxKey } from './constants';
export const getCommentState = (commentId)=>(state)=>commentId && state[reduxKey][commentId] || {};
export const isInitialized = (commentId)=>(state)=>commentId && state[reduxKey] !== undefined && state[reduxKey][commentId] !== undefined;
export const isFeatured = (commentId)=>(state)=>getCommentState(commentId)(state)['isFeatured'];
export const isLiked = (commentId)=>(state)=>getCommentState(commentId)(state)['isLiked'];
export const isHidden = (commentId)=>(state)=>getCommentState(commentId)(state)['isHidden'];
export const isSpam = (commentId)=>(state)=>getCommentState(commentId)(state)['isSpam'];
export const getLikes = (commentId)=>(state)=>getCommentState(commentId)(state)['likes'];
export const isCommentReduxReady = (state)=>!!state[reduxKey];
export function getCommentsByUser(state, userId) {
    const comments = state[reduxKey];
    const commentsByUser = [];
    for(const commentId in comments){
        var _comment_user, _comment;
        const comment = state[commentId];
        if (((_comment_user = (_comment = comment) === null || _comment === void 0 ? void 0 : _comment.user) === null || _comment_user === void 0 ? void 0 : _comment_user.userId) === userId) {
            commentsByUser.push(comment);
        }
    }
    return commentsByUser;
}
